<app-page-container>

  <div class="calc-container-content prime-fg-color-3">
    <div class="calcHeader">
      <span><b>{{'calculator' | translate}}</b></span>
    </div>

    <dx-form class="calcForm" #calcForm [minColWidth]="320" [formData]="formData" (onFieldDataChanged)="onFormFieldChanged()">
      <dxi-item>
        <div class="msg-text" [innerHtml]="hinweisText()"></div>
      </dxi-item>

      <dxi-item
        itemType="group"
        [colCount]="2">

        <dxi-item
          dataField="zeitraumAb"
          editorType="dxDateBox"
          [label]="{ text: 'periodFrom' | translate }"
          [colSpan]="1"
          [editorOptions]="{
            displayFormat: 'monthAndYear',
            valueChangeEvent: 'keyup',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            }
          }">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        @if (einrichtungenBeruecksichtigen) {
          <dxi-item
            dataField="einrichtungId"
            editorType="dxSelectBox"
            [label]="{ text: 'visited_daycare_center' | translate }"
            [colSpan]="1"
            [editorOptions]="{
              dataSource: einrichtungenDataSource,
              valueExpr: 'key',
              displayExpr: 'value',
              searchEnabled: true,
              searchMode: 'contains',
              searchTimeout: 200,
              searchExpr: 'value'
            }">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-item>
        <!-- }
        @else {
          <dxi-item itemtype="empty"></dxi-item> -->
        }
      </dxi-item>
      <dxi-item itemType="group" colCount="2">
        <dxi-item dataField="betreuungsArt" editorType="dxSelectBox"
          [label]="{ text: 'careType' | translate }" [colSpan]="1"
          [editorOptions]="{ tabIndex: 1, dataSource: betreuungsArtDataSource, valueExpr: 'id', displayExpr: 'bezeichnung',
          searchMode: 'startswith', searchTimeout: 200, searchExpr: 'bezeichnung', onValueChanged: onBetreuungsArtValueChanged }">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="betreuungsUmfang" editorType="dxSelectBox" [label]="{ text: 'careTime' | translate }"
          [colSpan]="1"
          [editorOptions]="{ tabIndex: 2, dataSource: betreuungsUmfangDataSource(), valueExpr: 'id', displayExpr: 'bezeichnung', searchMode: 'startswith',
            searchTimeout: 200, searchExpr: 'bezeichnung' }">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
      </dxi-item>

      <dxi-item itemType="group" colCount="2">
          <dxi-item  dataField="anzahlKinder" [label]="{ text: (istZaehl_KZ() ? 'positionOfKid' : 'numberKids') | translate }" editorType="dxNumberBox"
            [editorOptions]="{ valueChangeEvent:'keyup', min: 1, max: 10, format: (istZaehl_KZ() ? kind_format() : '') }">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-item>

        <dxi-item dataField="einkommen" [label]="{ text: einkommenText() }" [visible]="istEKAbhaengig" editorType="dxNumberBox"
          [editorOptions]="{ valueChangeEvent:'keyup', format: '#,##0.00 €', min: 0, max: 999999, disabled: formData.istMaxEinkommen, 
              showClearButton: true, value: formData.einkommen, step: 100}">
          @if (konfiguration()?.istEkAbhaengig && !formData.istMaxEinkommen) {
            <dxi-validation-rule type="required"></dxi-validation-rule>
          }
        </dxi-item>

      </dxi-item>
      <dxi-item itemType="group" colCount="2">
        <dxi-item dataField="istAlleinerziehend" editorType="dxCheckBox" [label]="{text: ' '}" [visible]="istEKAbhaengig"
          [editorOptions]="{ cssClass: 'checkbox-text', valueChangeEvent: 'keyup', text: 'singleParent' | translate }">
        </dxi-item>
        <dxi-item dataField="istMaxEinkommen" editorType="dxCheckBox" [label]="{text: ' '}" [visible]="istEKAbhaengig"
          [editorOptions]="{ cssClass: 'checkbox-text', valueChangeEvent: 'keyup', text: 'calcMaxFee' | translate }">
        </dxi-item>
    </dxi-item>

  </dx-form>

  @if (ergebnisVorhanden() && betrag() >= 0) {
    <div class="result-container result-ok"
      [style.visibility]="istBerechnet() ? null : 'hidden'"
      [attr.aria-hidden]="istBerechnet() ? null : 'true'">
      <span>{{'calcOkMessage' | translate }} {{betrag() | currency:'EUR': 'symbol'}}.</span>
    </div>
  }

  @if (ergebnisVorhanden() && betrag() !== -1 && konfiguration()?.gefunden === true) {
    <div class="result-container result-add">
      <span>{{'calcAddMessage' | translate }}</span>
    </div>
  }

  @if (ergebnisVorhanden() && betrag() === -1) {
    <div class="result-container result-fail"
      [style.visibility]="istBerechnet() ? null : 'hidden'"
      [attr.aria-hidden]="istBerechnet() ? null : 'true'">
      <span>{{'calcFailMessage_1' | translate }} <a href='#/extern/contact'>{{'calcFailMessage_2' | translate}}</a> {{'calcFailMessage_3' | translate }}</span>
    </div>
  }

  @if (konfiguration()?.gefunden === false) {
    <span class="result-container result-fail">
      {{ 'calcFailMessage_1' | translate }}
      <a href="#/extern/contact">
        {{ 'calcFailMessage_2' | translate }}
      </a>
      {{ 'calcFailMessage_3' | translate }}
    </span>
  } @else {
    <span class="result-container result-fail">{{msg()}}</span>
  }

  <dx-toolbar class="calcToolbar">
    <dxi-item widget="dxButton" location="after" toolbar="bottom"
      [options]="{ text: 'calculate' | translate, onClick: onCalcClick, type:'default', icon: 'check', stylingMode: 'filled', disabled: inProcess() || !kannBerechnen() }">
    </dxi-item>
    <dxi-item widget="dxButton" location="before" toolbar="bottom"
      [options]="{ text: 'clear' | translate, onClick: onClickReset, type:'default', icon: 'undo', stylingMode: 'filled' }">
    </dxi-item>
  </dx-toolbar>
</div>
</app-page-container>
